"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Award, Heart, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Valores() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const values = [{
    icon: Award,
    title: "Calidad Excepcional",
    description: "Cada pieza es seleccionada cuidadosamente por su calidad superior y diseño atemporal."
  }, {
    icon: Heart,
    title: "Diseño Consciente",
    description: "Apostamos por la moda sostenible y el consumo responsable sin sacrificar el estilo."
  }, {
    icon: Sparkles,
    title: "Elegancia Atemporal",
    description: "Creamos piezas que trascienden las tendencias pasajeras y permanecen relevantes."
  }];
  return <section id="valores" className="bg-secondary py-24 sm:py-32 overflow-hidden" ref={ref}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-4">
            Nuestros Valores
          </h2>
          <p className="text-lg text-white/70">
            Los pilares que definen la esencia de LUMIÈRE Boutique
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-12">
          {values.map((value, i) => {
          const Icon = value.icon;
          return <Card key={i} data-index={i} className={`bg-secondary/50 border-accent/20 hover:border-accent/40 backdrop-blur-sm group transition-all duration-500 ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardContent className="flex flex-col items-center text-center p-8 hover:-translate-y-2 transition-transform duration-500 ease-[var(--ease-out-back)]">
                  <div className="mb-6 transition-transform duration-700 ease-out group-hover:rotate-360 group-hover:scale-110">
                    <Icon className="size-16 text-accent" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display text-2xl font-semibold text-white mb-3 transition-transform duration-300 group-hover:-translate-y-1">
                    {value.title}
                  </h3>
                  <p className="text-white/60 leading-relaxed transition-transform duration-300 group-hover:-translate-y-1">
                    {value.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>

      <style jsx>{`
        @keyframes rotate-360 {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .group:hover .group-hover\\:rotate-360 {
          animation: rotate-360 0.7s ease-out;
        }
      `}</style>
    </section>;
}